import React from 'react';
import PropTypes from 'prop-types';
import clxBind from 'classnames/bind';
import styles from './styles.module.scss';

const clx = clxBind.bind(styles);

export default class Row extends React.Component {
  static propTypes = {
    vSpacing: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
    vColSpacing: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
    hColSpacing: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
    vColAlign: PropTypes.oneOf(['top', 'middle', 'bottom']),
    className: PropTypes.string,
    children: PropTypes.node,
  };

  static defaultProps = {
    vSpacing: 'lg',
    hColSpacing: 'lg',
    vColSpacing: 'lg',
    vColAlign: undefined,
    className: undefined,
    children: null,
  };

  render() {
    const { className, vSpacing, vColAlign, hColSpacing, vColSpacing, children } = this.props;

    const rowClasses = clx('row', className, {
      [`v-spacing-${vSpacing}`]: vSpacing,
      [`v-col-spacing-${vColSpacing}`]: vColSpacing,
      [`h-col-spacing-${hColSpacing}`]: hColSpacing,
    });

    return (
      <div className={rowClasses}>
        {React.Children.map(
          children,
          (child, index) =>
            child &&
            React.cloneElement(child, {
              key: index,
              vAlign: vColAlign,
              hSpacing: hColSpacing,
              vSpacing: vColSpacing,
            })
        )}
      </div>
    );
  }
}
